const hostname: any = 'staging.curebase.com';
export const IS_DOCKER_ENV: boolean = true;
export default hostname;
